import { Config } from "../../../api/config";
export var ProprietaryWarrantyKeys = {
    Paging: 'proprietaryWarrantyPaging',
    SearchByTypeList: 'getSearchTypeList',
    GetSearchByTypeResults: 'getSearchByTypeResponse',
    SearchByProductNameAndCode: 'searchByProductNameAndCode',
    VendorList: 'getVendorList',
    SystemName: 'ProprietaryWarrantyPartDetail',
    PartDetailsByProductId: 'getPartDetailsById',
    Create: 'proprietaryWarrantyCreate',
    Update: 'proprietaryWarrantyCreate',
    GetComplaintDelerCode: 'getComplaintDealerCode',
    Get: 'getProprietaryWarranty',
    GetCustomerDetails: 'getCustomerInfo',
    GetInstallBaseData: 'getInstallBaseData'
};
export var viewTypeOptions = ["My proprietary warranty", "All proprietary warranty"];
export var ProprietaryWarrantyMandatoryFields = {
    'Remarks': 'Remarks',
    'SettlementDate': 'SettlementDate',
    'PartGroup': 'PartGroup',
    'SerialNo': 'SerialNo',
    'SupplierId': 'SupplierId',
    'LocalVenderName': 'LocalVenderName',
    'DefectCodeId': 'DefectCodeId',
    'StatusId': 'StatusId'
};
export var ProprietaryWarrantyResetKeys = [ProprietaryWarrantyKeys.Paging, ProprietaryWarrantyKeys.Get, ProprietaryWarrantyKeys.GetSearchByTypeResults, ProprietaryWarrantyKeys.GetInstallBaseData, ProprietaryWarrantyKeys.GetComplaintDelerCode, ProprietaryWarrantyKeys.PartDetailsByProductId];
export var ProprietaryWarrantyApiKeys = [ProprietaryWarrantyKeys.GetSearchByTypeResults, ProprietaryWarrantyKeys.GetCustomerDetails, ProprietaryWarrantyKeys.GetInstallBaseData, ProprietaryWarrantyKeys.GetSearchByTypeResults];
export var proprietaryWarrantyPagingAPI = "".concat(Config.baseURL, "ProprietaryWarrantyHeader/Paging");
export var searchByProductNameAndCodeAPI = "".concat(Config.baseURL, "Product/ProprietaryProductListSearch");
export var complaintGroupAPI = "".concat(Config.baseURL, "ComplaintGroupPartServiceAssociation/GetPartbyComplaint");
export var proprietaryPartDetailsByProductIdAPI = "".concat(Config.baseURL, "ProprietaryWarrantyPartDetail/ByChildId");
export var proprietaryWarrantyCreateAPI = "".concat(Config.baseURL, "ProprietaryWarrantyHeader/CreateProprietaryWarrantyHeader");
export var complaintDealerCodeAPI = "".concat(Config.baseURL, "ComplaintGroupPartServiceAssociation/GetPartbyComplaint");
export var proprietaryWarrantyGetAPI = function (id) { return "".concat(Config.baseURL, "ProprietaryWarrantyHeader/").concat(id, "/Get"); };
export var getInstallBaseDataByIdAPI = "".concat(Config.baseURL, "Installbase/ByVinNumber");
